module.exports = {
	"root": "findify-layouts--recommendation--slider"
};